(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["te-pro-player"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var ROOT = document.getElementById('te-ps-root');
  if (!ROOT) return;
  function qs(s, c) { return (c || ROOT).querySelector(s); }
  function qsa(s, c) { return Array.from((c || ROOT).querySelectorAll(s)); }

  function toast(msg) {
    var t = qs('#te-ps-toast'); if (!t) return;
    var m = qs('#te-ps-tmsg'); if (m) m.textContent = msg;
    t.classList.add('te-ps-show'); clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('te-ps-show'); }, 2600);
  }
  function scrollTo(id) { var e = document.getElementById(id); if (e) e.scrollIntoView({ behavior: 'smooth' }); }
  function addToCart(vid, qty) {
    if (!vid || String(vid).indexOf('VID') > -1) { toast('Connect Shopify variant ID to add to cart'); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty || 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { toast(d.status ? 'Error: ' + (d.description || 'Could not add') : 'Added: ' + d.title); })
      .catch(function () { toast('Something went wrong.'); });
  }
  function addMultiple(items) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { toast(d.status ? 'Error: ' + (d.description || 'Could not add') : items.length + ' items added to cart'); })
      .catch(function () { toast('Something went wrong.'); });
  }

  /* PDP shoe sizes */
  var pdpSize = null, pdpVid = null;
  qsa('#te-ps-pdp-sizes .te-ps-sz').forEach(function (b) {
    b.addEventListener('click', function () {
      qsa('#te-ps-pdp-sizes .te-ps-sz').forEach(function (x) { x.classList.remove('te-ps-on'); });
      this.classList.add('te-ps-on'); pdpSize = this.dataset.s; pdpVid = this.dataset.vid;
      var l = qs('#te-ps-pdp-sz-lbl'); if (l) l.textContent = '— US ' + pdpSize + ' selected';
      var btn = qs('#te-ps-pdp-shoe-btn');
      if (btn) { btn.textContent = 'Add to Cart — Size ' + pdpSize; btn.style.opacity = '1'; btn.disabled = false; btn.onclick = function () { addToCart(pdpVid, 1); }; }
    });
  });

  /* Bundle builder */
  var bundleState = { racquet: true, strings: true, shoes: false, bag: true };
  var bundleShoeVid = null;
  function getBundlePrice(id) { var e = qs('#te-ps-bi-' + id); return e ? parseFloat(e.dataset.price || 0) : 0; }
  function bundleToggle(id, e) {
    if (e && e.target && e.target.closest('.te-ps-bi-sz-expander')) return;
    bundleState[id] = !bundleState[id];
    var el = qs('#te-ps-bi-' + id), pr = qs('#te-ps-bi-' + id + '-price');
    if (!el) return;
    if (bundleState[id]) { el.classList.add('te-ps-checked'); if (pr) pr.classList.remove('te-ps-dimmed'); }
    else {
      el.classList.remove('te-ps-checked'); if (pr) pr.classList.add('te-ps-dimmed');
      if (id === 'shoes') {
        bundleShoeVid = null;
        qsa('#te-ps-bundle-sz-grid .te-ps-bsz').forEach(function (b) { b.classList.remove('te-ps-on'); });
        var s = qs('#te-ps-bundle-sz-selected'); if (s) { s.style.display = 'none'; s.textContent = ''; }
      }
    }
    updateTotal();
  }
  qsa('#te-ps-bundle-sz-grid .te-ps-bsz').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      qsa('#te-ps-bundle-sz-grid .te-ps-bsz').forEach(function (x) { x.classList.remove('te-ps-on'); });
      this.classList.add('te-ps-on'); bundleShoeVid = this.dataset.vid;
      var sel = qs('#te-ps-bundle-sz-selected'); if (sel) { sel.textContent = ' — US ' + this.dataset.s; sel.style.display = 'inline'; }
      var n = qs('#te-ps-bi-shoes-note'); if (n) n.textContent = 'Size US ' + this.dataset.s + ' selected';
      var w = qs('#te-ps-shoe-warn'); if (w) w.style.display = 'none';
      updateTotal();
    });
  });
  function updateTotal() {
    var total = 0, count = 0;
    Object.keys(bundleState).forEach(function (id) { if (bundleState[id]) { total += getBundlePrice(id); count++; } });
    var v = qs('#te-ps-bt-val'); if (v) { v.textContent = count > 0 ? '$' + total.toFixed(2) : '$0.00'; v.className = 'te-ps-bt-val' + (count === 0 ? ' te-ps-zero' : ''); }
    var s = qs('#te-ps-bt-summary'); if (s) s.textContent = count === 0 ? 'No items selected' : count === 1 ? '1 item selected' : count + ' items selected';
    var n = qs('#te-ps-bt-note'); if (n) { n.textContent = (bundleState.shoes && !bundleShoeVid) ? 'Select a shoe size above' : ''; n.style.color = '#f5a623'; }
  }
  function addBundle() {
    var ids = Object.keys(bundleState).filter(function (id) { return bundleState[id]; });
    if (!ids.length) { toast('Select at least one item'); return; }
    if (bundleState.shoes && !bundleShoeVid) {
      var el = qs('#te-ps-bi-shoes'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var w = qs('#te-ps-shoe-warn'); if (w) w.style.display = 'block';
      toast('Please select a shoe size first'); return;
    }
    var items = [];
    ids.forEach(function (id) {
      var el = qs('#te-ps-bi-' + id);
      var vid = id === 'shoes' ? bundleShoeVid : (el ? el.dataset.vid : null);
      if (vid && String(vid).indexOf('VID') === -1) items.push({ id: parseInt(vid, 10), quantity: 1 });
    });
    if (!items.length) { toast('Connect Shopify variant IDs to enable bundle cart'); return; }
    addMultiple(items);
  }

  if (qs('#te-ps-bundle')) updateTotal();
  window.TEPS = { addToCart: addToCart, bundleToggle: bundleToggle, addBundle: addBundle, scrollTo: scrollTo, toast: toast };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-brands"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('te-rcq-brands-{{ section.id }}');
  if (!root) return;

  function buildFilterUrl() {
    var form = document.getElementById('FilterForm');
    if (!form) return window.location.pathname;
    var data = new FormData(form);
    var params = new URLSearchParams();
    for (var pair of data.entries()) {
      if (pair[1]) params.append(pair[0], pair[1]);
    }
    var str = params.toString();
    return window.location.pathname + (str ? '?' + str : '');
  }

  root.querySelectorAll('.te-rcq-brand-card').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var brand = btn.dataset.brand;
      var vendorCbs = document.querySelectorAll('input[name^="filter.p.vendor"]');
      if (vendorCbs.length > 0) {
        vendorCbs.forEach(function (cb) {
          cb.checked = cb.value.toLowerCase() === brand;
        });
        window.location = buildFilterUrl();
      } else {
        var url = btn.dataset.filterUrl;
        if (url) window.location = url;
      }
    });
  });

  var params = new URLSearchParams(window.location.search);
  var activeVendor = params.get('filter.p.vendor');
  if (activeVendor) {
    root.querySelectorAll('.te-rcq-brand-card').forEach(function (btn) {
      if (btn.dataset.brand === activeVendor.toLowerCase()) {
        btn.classList.add('te-rcq-brand-btn--active');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }

  var scroll = document.getElementById('te-rcq-brands-scroll-{{ section.id }}');
  var prev   = document.getElementById('te-rcq-brands-prev-{{ section.id }}');
  var next   = document.getElementById('te-rcq-brands-next-{{ section.id }}');
  if (scroll && prev && next) {
    var STEP = 200;
    function updateArrows() {
      prev.disabled = scroll.scrollLeft <= 0;
      next.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 1;
    }
    prev.addEventListener('click', function () { scroll.scrollBy({ left: -STEP, behavior: 'smooth' }); });
    next.addEventListener('click', function () { scroll.scrollBy({ left: STEP, behavior: 'smooth' }); });
    scroll.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-chips"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__teRcqChipsBound) return;
  window.__teRcqChipsBound = true;

  function syncChipActiveStates() {
    var current = new URL(window.location.href);
    document.querySelectorAll('.te-rcq-chip').forEach(function (chip) {
      var raw = chip.getAttribute('data-liquid-url');
      if (!raw) return;
      var chipUrl = new URL(raw, window.location.origin);
      var filterQuery = chip.getAttribute('data-filter-query') || '';
      var samePath = chipUrl.pathname === current.pathname;
      var active = false;

      if (samePath) {
        if (!filterQuery) {
          active = !current.search.includes('filter.');
        } else {
          active = current.search.includes(filterQuery) || decodeURIComponent(current.search).includes(filterQuery);
        }
      }

      chip.classList.toggle('te-rcq-chip--active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  async function loadCollection(url) {
    var collectionRoot = document.querySelector('[data-te-rcq-section="collection"]');
    if (!collectionRoot) {
      window.location = url;
      return;
    }

    var sectionEl = collectionRoot.closest('[id^="shopify-section-"]');
    var sectionId = collectionRoot.getAttribute('data-section-id')
      || (sectionEl && sectionEl.id.replace(/^shopify-section-/, ''));

    if (!sectionId || !sectionEl) {
      window.location = url;
      return;
    }

    var fetchUrl = new URL(url, window.location.origin);
    // Keep alternate template if the chip URL omitted it
    var currentView = new URLSearchParams(window.location.search).get('view');
    if (currentView && !fetchUrl.searchParams.has('view')) {
      fetchUrl.searchParams.set('view', currentView);
    }
    fetchUrl.searchParams.set('sections', sectionId);

    collectionRoot.classList.add('is-loading');
    document.querySelectorAll('.te-rcq-chip').forEach(function (c) { c.classList.add('is-loading'); });

    try {
      var res = await fetch(fetchUrl.toString(), {
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Section fetch failed');
      var data = await res.json();
      var html = data[sectionId];
      if (!html) throw new Error('Missing section HTML');

      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newSection = temp.querySelector('[id^="shopify-section-"]') || temp.firstElementChild;
      if (!newSection) throw new Error('Invalid section markup');

      sectionEl.replaceWith(newSection);

      var nextUrl = new URL(url, window.location.origin);
      if (currentView && !nextUrl.searchParams.has('view')) {
        nextUrl.searchParams.set('view', currentView);
      }
      history.pushState({ teRcqFilter: true }, '', nextUrl.pathname + nextUrl.search);
      syncChipActiveStates();
      document.dispatchEvent(new CustomEvent('te-rcq:collection:updated'));

      var updated = document.querySelector('[data-te-rcq-section="collection"]');
      if (updated) {
        updated.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (err) {
      window.location = url;
    } finally {
      document.querySelectorAll('.te-rcq-chip.is-loading').forEach(function (c) {
        c.classList.remove('is-loading');
      });
      var root = document.querySelector('[data-te-rcq-section="collection"]');
      if (root) root.classList.remove('is-loading');
    }
  }

  window.teRcqLoadCollection = loadCollection;

  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('.te-rcq-chip') : null;
    if (!chip) return;
    e.preventDefault();
    var url = chip.getAttribute('data-liquid-url');
    if (url) loadCollection(url);
  });

  window.addEventListener('popstate', function () {
    loadCollection(window.location.pathname + window.location.search);
  });

  document.addEventListener('te-rcq:collection:updated', syncChipActiveStates);

  // Fade edges on horizontal chip scroll
  document.querySelectorAll('[data-te-rcq-section="chips"]').forEach(function (root) {
    var chipsSection = root.querySelector('.te-rcq-chips');
    var chipsScroll = root.querySelector('.te-rcq-chips-scroll');
    if (!chipsSection || !chipsScroll) return;
    chipsScroll.addEventListener('scroll', function () {
      chipsSection.classList.toggle('te-rcq-chips--scrolled', chipsScroll.scrollLeft > 8);
    }, { passive: true });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = document.getElementById('te-rcq-root');
  if (!ROOT) return;

  var SECTION_ID = ROOT.dataset.sectionId || '';

  function qs(sel, ctx)  { return (ctx || ROOT).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || ROOT).querySelectorAll(sel)); }

  /* ── Build filter URL from current form state ───────────── */
  function buildFilterUrl() {
    var form = document.getElementById('FilterForm');
    if (!form) return window.location.pathname;
    var data   = new FormData(form);
    var params = new URLSearchParams();
    for (var pair of data.entries()) {
      if (pair[1]) params.append(pair[0], pair[1]);
    }
    var str = params.toString();
    return window.location.pathname + (str ? '?' + str : '');
  }

  /* ── Toggle one string_type2 value in/out of the current URL ─
     Preserves all other active filters and any already-selected
     string types, enabling multi-select custom chips. */
  function toggleStringType(value) {
    var params = new URLSearchParams(window.location.search);
    var key    = 'filter.p.m.custom.string_type2';
    var existing = params.getAll(key);
    var idx = existing.indexOf(value);
    params.delete(key);
    if (idx === -1) existing.push(value);
    else existing.splice(idx, 1);
    existing.forEach(function (v) { params.append(key, v); });
    var str = params.toString();
    return window.location.pathname + (str ? '?' + str : '');
  }

  /* ── AJAX navigation via Section Rendering API ───────────── */
  var fetchCtrl = null;

  function navigateFetch(url, skipPush) {
    if (fetchCtrl) fetchCtrl.abort();
    fetchCtrl = new AbortController();

    var gridMain = qs('.te-rcq-grid-main');
    if (gridMain) {
      gridMain.style.opacity      = '0.4';
      gridMain.style.pointerEvents = 'none';
      gridMain.style.transition   = 'opacity .15s';
    }

    var sep      = url.indexOf('?') !== -1 ? '&' : '?';
    var fetchUrl = SECTION_ID ? url + sep + 'sections=' + encodeURIComponent(SECTION_ID) : url;

    fetch(fetchUrl, { signal: fetchCtrl.signal })
      .then(function (r) { return SECTION_ID ? r.json() : r.text(); })
      .then(function (payload) {
        var html = SECTION_ID ? (payload[SECTION_ID] || Object.values(payload)[0] || '') : payload;
        var doc  = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = doc.querySelector('#te-rcq-grid');
        var oldGrid = qs('#te-rcq-grid');
        if (newGrid && oldGrid) oldGrid.replaceWith(newGrid);

        var newCount = doc.querySelector('.te-rcq-toolbar-count');
        var oldCount = qs('.te-rcq-toolbar-count');
        if (newCount && oldCount) oldCount.textContent = newCount.textContent;

        var newPag = doc.querySelector('.te-rcq-pagination');
        var oldPag = qs('.te-rcq-pagination');
        if (oldPag) oldPag.remove();
        if (newPag) { var g = qs('#te-rcq-grid'); if (g) g.after(newPag); }

        var newSidebar = doc.querySelector('#te-rcq-filters');
        var oldSidebar = qs('#te-rcq-filters');
        if (newSidebar && oldSidebar) oldSidebar.replaceWith(newSidebar);

        if (!skipPush) history.pushState({}, '', url);

        syncChips();
        syncBrandStrip();

        if (gridMain) {
          gridMain.style.opacity      = '1';
          gridMain.style.pointerEvents = '';
        }

        initReveal(qs('#te-rcq-grid'));
        fetchCtrl = null;
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') window.location = url;
      });
  }

  /* ── Sync chip highlight from URL ───────────────────────── */
  /* Handles three chip families:
     - Built-in racquet chips (data-filter: all/under-250/on-sale/demo/pro-worn)
     - Custom filter chips (data-filter: custom / custom-all), matched by the
       filter.p.m.custom.string_type2 param against data-filter-value.
     - Plain anchor chips (no data-filter) are left as rendered. */
  function syncChips() {
    var params      = new URLSearchParams(window.location.search);
    var tag         = (params.get('filter.p.tag') || '').toLowerCase();
    var stringTypes = params.getAll('filter.p.m.custom.string_type2');

    qsa('.te-rcq-chip').forEach(function (chip) {
      var f = chip.dataset.filter;
      if (!f) return;

      var active = false;
      if      (f === 'custom-all') active = stringTypes.length === 0;
      else if (f === 'custom')     active = stringTypes.indexOf(chip.dataset.filterValue || '') !== -1;
      else if (f === 'all')        active = !params.has('filter.p.tag') && !params.has('filter.v.price.lte') && !params.has('filter.p.vendor');
      else if (f === 'beginner')   active = tag === 'beginner';
      else if (f === 'under-250')  active = params.has('filter.v.price.lte');
      else if (f === 'on-sale')    active = tag === 'sale';
      else if (f === 'demo')       active = tag === 'demo available';
      else if (f === 'pro-worn')   active = tag === 'pro worn';

      chip.classList.toggle('te-rcq-chip--active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ── Sync brand strip highlight from URL ────────────────── */
  function syncBrandStrip() {
    var params       = new URLSearchParams(window.location.search);
    var activeVendor = (params.get('filter.p.vendor') || '').toLowerCase();

    qsa('.te-rcq-brand-card').forEach(function (btn) {
      var active = btn.dataset.brand === activeVendor;
      btn.classList.toggle('te-rcq-brand-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) showBrandCta(btn);
    });

    if (!activeVendor) hideBrandCta();
  }

  function showBrandCta(btn) {
    var label   = btn.dataset.label || btn.dataset.brand;
    var ctaEl   = qs('#te-rcq-brand-cta');
    var ctaMsg  = qs('#te-rcq-brand-cta-msg');
    var ctaLink = qs('#te-rcq-brand-cta-link');
    if (!ctaEl) return;
    if (ctaMsg)  ctaMsg.textContent = 'Showing ' + label + ' racquets';
    if (ctaLink) {
      ctaLink.textContent = 'View all ' + label + ' Racquets →';
      ctaLink.href = window.location.pathname + '?filter.p.vendor=' + encodeURIComponent(label);
    }
    ctaEl.classList.add('te-rcq-brand-cta--visible');
  }

  function hideBrandCta() {
    var ctaEl = qs('#te-rcq-brand-cta');
    if (ctaEl) ctaEl.classList.remove('te-rcq-brand-cta--visible');
  }

  function handleBrandClick(btn) {
    var label    = btn.dataset.label;
    var isActive = btn.classList.contains('te-rcq-brand-btn--active');

    var allCbs  = qsa('input.te-rcq-filter-input[type="checkbox"]');
    var matched = null;
    for (var i = 0; i < allCbs.length; i++) {
      if (allCbs[i].value.toLowerCase() === label.toLowerCase()) { matched = allCbs[i]; break; }
    }

    var url;
    if (matched) {
      allCbs.forEach(function (cb) { if (cb.name === matched.name) cb.checked = false; });
      if (!isActive) matched.checked = true;
      url = buildFilterUrl();
    } else {
      url = isActive
        ? window.location.pathname
        : window.location.pathname + '?filter.p.vendor=' + encodeURIComponent(label);
    }
    navigateFetch(url);
  }

  function openFilters() {
    var s = qs('#te-rcq-filters'), b = qs('#te-rcq-filter-backdrop'), t = qs('#te-rcq-filter-btn');
    if (s) s.classList.add('te-rcq-filters--open');
    if (b) b.classList.add('te-rcq-filter-backdrop--open');
    if (t) t.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    var s = qs('#te-rcq-filters'), b = qs('#te-rcq-filter-backdrop'), t = qs('#te-rcq-filter-btn');
    if (s) s.classList.remove('te-rcq-filters--open');
    if (b) b.classList.remove('te-rcq-filter-backdrop--open');
    if (t) t.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  /* ── Event delegation (survives sidebar swaps) ──────────── */
  ROOT.addEventListener('click', function (e) {
    if (e.target.closest('.te-rcq-brand-card'))      { handleBrandClick(e.target.closest('.te-rcq-brand-card')); return; }
    if (e.target.closest('#te-rcq-brand-cta-clear')) { navigateFetch(window.location.pathname); return; }
    if (e.target.closest('.te-rcq-price-apply'))     { navigateFetch(buildFilterUrl()); return; }
    if (e.target.closest('.te-rcq-filters-clear'))   { e.preventDefault(); navigateFetch(e.target.closest('.te-rcq-filters-clear').href); return; }
    if (e.target.closest('.te-rcq-page-link'))       { e.preventDefault(); navigateFetch(e.target.closest('.te-rcq-page-link').href); return; }
    if (e.target.closest('#te-rcq-filter-backdrop')) { closeFilters(); return; }

    /* Custom string-type chips multi-select: toggle this value in/out of the
       existing string_type2 params, preserving any other active filters.
       The "All" reset chip (custom-all) and built-in chips still use
       data-liquid-url for single-value navigation. */
    var chip = e.target.closest('.te-rcq-chip');
    if (chip && chip.dataset.filter === 'custom') {
      navigateFetch(toggleStringType(chip.dataset.filterValue || ''));
      return;
    }
    if (chip && chip.dataset.liquidUrl) { navigateFetch(chip.dataset.liquidUrl); return; }
  });

  ROOT.addEventListener('change', function (e) {
    if (e.target.matches('input.te-rcq-filter-input')) { navigateFetch(buildFilterUrl()); return; }
    if (e.target.matches('.te-rcq-sort'))              { navigateFetch(buildFilterUrl()); return; }
  });

  var filterBtn = qs('#te-rcq-filter-btn');
  if (filterBtn) {
    filterBtn.addEventListener('click', function () {
      var s = qs('#te-rcq-filters');
      if (s && s.classList.contains('te-rcq-filters--open')) closeFilters(); else openFilters();
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });

  function initReveal(container) {
    if (!window.IntersectionObserver) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity   = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });
    var scope = container || ROOT;
    var selector = container ? '.te-rcq-pc, .te-rcq-banner' : '.te-rcq-pc, .te-rcq-banner, .te-rcq-tile, .te-rcq-pro-card';
    qsa(selector, scope).forEach(function (el) {
      el.style.opacity    = '0';
      el.style.transform  = 'translateY(16px)';
      el.style.transition = 'opacity .35s ease, transform .35s ease';
      observer.observe(el);
    });
  }

  function initBrandArrows() {
    var scroll = qs('#te-rcq-brands-scroll');
    var prev   = qs('#te-rcq-brands-prev');
    var next   = qs('#te-rcq-brands-next');
    if (!scroll || !prev || !next) return;
    var STEP = 200;
    function updateArrows() {
      prev.disabled = scroll.scrollLeft <= 0;
      next.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 1;
    }
    prev.addEventListener('click', function () { scroll.scrollBy({ left: -STEP, behavior: 'smooth' }); });
    next.addEventListener('click', function () { scroll.scrollBy({ left:  STEP, behavior: 'smooth' }); });
    scroll.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  function initChipsScroll() {
    var sec = qs('.te-rcq-chips'), scroll = qs('.te-rcq-chips-scroll');
    if (!sec || !scroll) return;
    scroll.addEventListener('scroll', function () {
      sec.classList.toggle('te-rcq-chips--scrolled', scroll.scrollLeft > 8);
    }, { passive: true });
  }

  window.addEventListener('popstate', function () {
    navigateFetch(window.location.href, true);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncChips();
    syncBrandStrip();
    initReveal();
    initBrandArrows();
    initChipsScroll();
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__teRcqCollectionBound) return;
  window.__teRcqCollectionBound = true;

  function getRoot() {
    return document.querySelector('[data-te-rcq-section="collection"]');
  }

  function buildFilterUrl() {
    var form = document.querySelector('[data-te-rcq-filter-form]') || document.getElementById('FilterForm');
    var root = getRoot();
    var path = (root && root.getAttribute('data-collection-url')) || window.location.pathname;
    var params = new URLSearchParams();

    if (form) {
      var data = new FormData(form);
      for (var pair of data.entries()) {
        if (pair[1]) params.append(pair[0], pair[1]);
      }
    }

    // Always keep alternate template (?view=racquet-collection-v2)
    var currentView = new URLSearchParams(window.location.search).get('view');
    if (currentView && !params.has('view')) params.set('view', currentView);

    var str = params.toString();
    return path + (str ? '?' + str : '');
  }

  function animateCards(root) {
    if (!root || !window.IntersectionObserver) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    root.querySelectorAll('.te-rcq-pc, .te-rcq-banner').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .35s ease, transform .35s ease';
      observer.observe(el);
    });
  }

  function bindMobileFilters(root) {
    if (!root) return;
    var toggleBtn = root.querySelector('.te-rcq-filter-toggle');
    var sidebar = root.querySelector('.te-rcq-filters');
    var backdrop = root.querySelector('.te-rcq-filter-backdrop');
    if (!toggleBtn || !sidebar) return;

    function openFilters() {
      sidebar.classList.add('te-rcq-filters--open');
      if (backdrop) backdrop.classList.add('te-rcq-filter-backdrop--open');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      sidebar.classList.remove('te-rcq-filters--open');
      if (backdrop) backdrop.classList.remove('te-rcq-filter-backdrop--open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggleBtn.addEventListener('click', function () {
      sidebar.classList.contains('te-rcq-filters--open') ? closeFilters() : openFilters();
    });
    if (backdrop) backdrop.addEventListener('click', closeFilters);
  }

  function initCollection() {
    var root = getRoot();
    if (!root) return;
    bindMobileFilters(root);
    animateCards(root);
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('te-rcq-filter-input')) return;
    var url = buildFilterUrl();
    if (window.teRcqLoadCollection) {
      window.teRcqLoadCollection(url);
    } else {
      window.location = url;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var root = getRoot();
    if (!root) return;
    var sidebar = root.querySelector('.te-rcq-filters');
    var backdrop = root.querySelector('.te-rcq-filter-backdrop');
    var toggleBtn = root.querySelector('.te-rcq-filter-toggle');
    if (sidebar) sidebar.classList.remove('te-rcq-filters--open');
    if (backdrop) backdrop.classList.remove('te-rcq-filter-backdrop--open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  });

  document.addEventListener('te-rcq:collection:updated', initCollection);
  initCollection();

  window.teRcqBuildFilterUrl = buildFilterUrl;
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-pros"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('te-rcq-pros-{{ section.id }}');
  if (!root || !window.IntersectionObserver) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  root.querySelectorAll('.te-rcq-pro-card').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .35s ease, transform .35s ease';
    observer.observe(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-titles"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('te-rcq-tiles-{{ section.id }}');
  if (!root || !window.IntersectionObserver) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  root.querySelectorAll('.te-rcq-tile').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .35s ease, transform .35s ease';
    observer.observe(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-shoes-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.te-shoe-tailored');
  if (!roots.length) return;
  var INITIAL_VISIBLE = 12;

  roots.forEach(function(root){
    var grid     = root.querySelector('[data-tailored-grid]');
    var tabs     = root.querySelectorAll('.te-shoe-tailored-brand');
    var titleEl  = root.querySelector('[data-tailored-title]');
    var viewallEl = root.querySelector('[data-tailored-viewall]');
    if (!grid || !tabs.length) return;
    var BRAND_VISIBLE = parseInt(grid.getAttribute('data-brand-visible'), 10) || 24;
    var cards = grid.querySelectorAll('.te-shoe-tailored-card');

    function syncMeta(label, href){
      if (titleEl) titleEl.textContent = label || (titleEl.getAttribute('data-default') || '');
      if (viewallEl) {
        viewallEl.textContent = href ? 'View All ' + label : (viewallEl.getAttribute('data-default-text') || 'View all');
        viewallEl.href = href || viewallEl.getAttribute('data-default-href') || '#';
      }
    }
    function applyAll(){
      var n = 0;
      cards.forEach(function(c){
        if (c.hasAttribute('data-brand-only')) {
          c.setAttribute('hidden', '');
        } else {
          if (n < INITIAL_VISIBLE) c.removeAttribute('hidden');
          else c.setAttribute('hidden', '');
          n++;
        }
      });
      syncMeta(null, null);
    }
    function applyBrand(brand, label, collUrl){
      var n = 0;
      cards.forEach(function(c){
        var match = (c.getAttribute('data-brand') || '').toLowerCase() === brand;
        if (match) {
          if (n < BRAND_VISIBLE) c.removeAttribute('hidden');
          else c.setAttribute('hidden', '');
          n++;
        } else {
          c.setAttribute('hidden', '');
        }
      });
      syncMeta(label + ' Shoes', collUrl);
    }
    applyAll();

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        tabs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var brand    = (tab.getAttribute('data-brand') || '').toLowerCase().trim();
        var label    = tab.getAttribute('data-brand-label') || brand;
        var collUrl  = tab.getAttribute('data-brand-url') || '';
        if (!brand) applyAll();
        else applyBrand(brand, label, collUrl);
      });
    });

    // Brand strip slider — arrows + fade hints based on overflow + scroll position
    var outer = root.querySelector('[data-brands-outer]');
    var wrap  = root.querySelector('[data-brands-wrap]');
    var prev  = root.querySelector('[data-brands-prev]');
    var next  = root.querySelector('[data-brands-next]');
    if (outer && wrap) {
      function update(){
        var max = wrap.scrollWidth - wrap.clientWidth;
        var x = wrap.scrollLeft;
        var canLeft  = x > 2;
        var canRight = x < max - 2;
        outer.setAttribute('data-can-scroll-left',  canLeft  ? 'true' : 'false');
        outer.setAttribute('data-can-scroll-right', canRight ? 'true' : 'false');
        if (prev) prev.hidden = !canLeft;
        if (next) next.hidden = !canRight;
      }
      function step(){
        // Scroll by ~3 brand cards (88px + 10px gap) on each click
        return Math.max(180, Math.min(wrap.clientWidth * 0.7, 320));
      }
      if (prev) prev.addEventListener('click', function(){ wrap.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function(){ wrap.scrollBy({ left:  step(), behavior: 'smooth' }); });
      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Run on next frame so logos finish loading and widths settle
      requestAnimationFrame(update);
      setTimeout(update, 400);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
